module.exports = __webpack_public_path__ + "static/media/Vector.f9bb2281.svg";